import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { BButton, BDropdownItem, BModal, BOverlay, VBTooltip } from 'bootstrap-vue'
import { TranslateResult } from 'vue-i18n'
import { VueConstructor } from 'vue'
import { Spinner } from '@kwixeo/interface-vue'

@Component({
  components: {
    BModal,
    BOverlay,
    Spinner
  },
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class ManualMovementDelete extends Vue {
  @Prop({ required: true }) value!: KwixeoCatalog.StockManualMovement|null
  @Prop({ default: 'button' }) element!: 'button'|'dropdown'|'modal'
  @Prop({ default: null }) label!: TranslateResult|string
  @Prop({ default: null }) variant!: string|null
  @Prop({ default: false }) disabled!: boolean
  @Prop({ default: null }) title!: string|null
  @Prop({ default: false }) modal!: boolean

  private modalState = false
  private loading = false
  private errorMsg = null

  get component (): VueConstructor|null {
    switch (this.element) {
      case 'button':
        return BButton
      case 'dropdown':
        return BDropdownItem
      default:
        return null
    }
  }

  get buttonLabel (): TranslateResult|string {
    return this.label ?? this.$t('interface.delete')
  }

  @Watch('modal', { immediate: true })
  private watchModal (state: boolean): void {
    this.modalState = state
  }

  @Watch('modalState')
  private watchModalState (state: boolean): void {
    if (!state) {
      this.loading = false
    }
  }

  private async process (): Promise<void> {
    this.loading = true
    await this.$kwCatalog.axios.delete('/catalog/stock/manual/' + this.value?.id)
      .then(() => {
        this.deleted()
        this.closeModal()
      })
      .catch(error => {
        throw new Error(error)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private closeModal (): void {
    this.$emit('closed')
  }

  private canceled (): void {
    this.$emit('canceled')
  }

  private deleted (): void {
    this.$emit('deleted', this.value)
    this.closeModal()
  }

}
